// Původní název:		sk.widgets.Carousel
// Původní umístění:	shared/js/widget/sk.widgets.Carousel.js
// Status:				Používáno
// Funkcionalita:		Carousely

// Poznámky:			Widget Carousel
//						version 3
// 						Created: 14.02.2012 | Michal Matuška(michal.matuska@superkoderi.cz)

// TODO BUG - při procházení tabů na stránce Recenze hotelů se taby rozbijí
// TODO - nepodporuje swipe adpod. - nenahradíme jej něčím novějším a funkčnějším - třeba slickem?
// #CHECKED jthiemel 190108


import $ from 'jquery';
import Pager from './pager';


class Carousel {
	constructor(element, options) {
		this.$element = element.jquery ? element : $(element);
		this.options = $.extend({
			// elementy ktere se budou scrollovat
			item: '>*',
			// počet elementů k které se bude posouvat
			scroll: 1,
			// aktuální krok
			position: 0,
			// fullscreen režim, bude scrollovat o procenta
			fullscreen: true,
			// skok na začátek
			repeat: false,
			// nekonečné scrollování
			infinite: false,
			// čas za který se provede animace kroku. 0 vypne animaci a bude jen přepínat
			animation: 500,
			// efekt animace
			easing: 'swing',
			// osa
			axis: 'x', // x, y
			// ovládací prvek pro předchozí
			pagerPrev: null,
			// ovládací prvek pro další
			pagerNext: null,
			// vygenerovat menu pro kroky
			pagerPages: null,
			// maska kroků
			pagerMask: null,
			pagerMaskString: '{$active}/{$all}', // {$active} = aktivní položka, {$all} = celkový počet
			// timeout po které se automatiky přepne na další krok. 0 znamená že se automaticky neposunuje
			timeout: 0,
			// callbacky
			onChange: null,
			onInit: null,
			// offset
			offset: 0,
			// prázdnej element pro doplnění kroku
			emptyHolder: '<li class="empty"></li>',
		}, options);

		this.axProps = this.options.axis == 'x' ?
			{
				left: 'left',
				width: 'width',
				outerWidth: 'outerWidth',
				scrollWidth: 'scrollWidth',
				scrollLeft: 'scrollLeft',
				offset: 'offsetLeft',
			} :
			{
				left: 'top',
				width: 'height',
				outerWidth: 'outerHeight',
				scrollWidth: 'scrollHeight',
				scrollLeft: 'scrollTop',
				offset: 'offsetTop',
			};

		this.size = this.$element[this.axProps.width]() || 0;
		this.sizeScroll = this.$element.prop(this.axProps.scrollWidth) || 0;
		this.delta = this.sizeScroll - this.size;
		this.position = this.options.position;
		this.scroll = 0;
		this.min = 0;
		this.max = 0;

		return this;
	}

	init() {
		if (!this.$element.length) {
			return this;
		}

		var o = this.options;

		this.$holder = this.$element[this.axProps.scrollLeft](0).wrap('<div class="sk-carousel sk-carousel-' + o.axis + '"></div>').parent();
		this.$originalItems = this.$items = this.$element.find(o.item);

		this.infinite = o.infinite;
		this.clonedCount = 0;
		if (this.infinite) {
			this.clonedCount = this.createInfinite();
			this.$items = this.$element.find(o.item);


		}

		this.length = this.$items.length;

		this.repeat = o.repeat;
		this.scroll = this.getScroll();
		this.steps = this.getSteps();
		this.min = 0;
		this.max = this.steps.length - this.clonedCount * 2 - 1;

		this.animated = o.animation ? true : false;
		this.mainTimer = null;
		// přepnutí událostí
		this.handled = false;

		// pager
		this.pager = new Pager({
			current: this.position,
			max: this.max,
			infinite: this.repeat || this.infinite,
			pagerPrev: o.pagerPrev,
			pagerNext: o.pagerNext,
			pagerPages: o.pagerPages,
			pagerMask: o.pagerMask,
			pagerMaskString: o.pagerMaskString,
			// callbacky
			onChange: $.proxy(function (obj) {
				this.clearInterval();
				this.handled = true;
				if (obj.prev) var pos = this.infinite ? (this.position - 1) : obj.current;
				if (obj.next) var pos = this.infinite ? (this.position + 1) : obj.current;
				if (obj.page) var pos = obj.current;
				this.setPosition(pos, this.animated);
			}, this),
		});
		this.pager.init();

		this.setPosition(this.position, false, true);

		this.isInit = true;

		typeof o.onInit === 'function' && o.onInit.call(this);

		return this;
	}

	destroy() {
		var o = this.options;

		// odstraní holder
		this.$element.unwrap();
		this.$holder = null;
		delete this.$holder;

		// odstraní itemy
		this.$items = null;
		delete this.$items;
		delete this.length;

		this.pager.destroy();

		// timer
		if (o.timeout) {
			this.clearInterval();
			delete this.mainTimer;
		}

		this.isInit = false;
	}

	setPosition(pos, animate, init, animCall) {
		var o = this.options;
		this.$element.stop(true, true);

		if (this.infinite) {
			var pos = pos;
		}
		else {
			var pos = (pos > this.max) ? this.max : (pos < this.min) ? this.min : pos;
		}

		if (this.position != pos || init || animCall) {


			var params = {};
			params[this.axProps.left] = this.steps[pos + this.clonedCount];

			if (animate) {
				this.$element.animate(params, o.animate, o.easing, $.proxy(function () {
					this.setPosition(pos, false, false, true);
				}, this));
				//this.$element.css('-webkit-transform', 'translate3d('+ scroll +',0,0)');
			}
			else {
				//this.$element.css('-webkit-transform', 'translate3d('+ scroll +',0,0)');
				this.$element.css(params);
				this.resetInterval();
			}

			if (!animCall) {
				// převrátit pozice pokud je opakovaní
				if (this.infinite) {
					pos = (pos < this.min) ? this.max : (pos > this.max) ? this.min : pos;
				}
				this.position = pos;
			}


			if (!init && !animCall) {
				// callback
				typeof o.onChange == 'function' && o.onChange.call(this, { position: pos, handled: this.handled });
			}
		}

		this.handled = false;
	}

	getPosition() {
		return this.position;
	}

	getSteps() {
		var arr = [];
		var o = this.options;

		var prop = this.axProps.left;
		var delta = this.delta;
		var length = this.$items.length;

		for (var i = 0; i < length; i = i + this.scroll) {
			if (o.fullscreen) {
				var scroll = (i * -100) + '%';
				arr.push(scroll);
			}
			else {
				// TODO - this may be the potential problem causing
				var scroll = -this.$items.eq(i).position()[prop] - ((i == 0) ? 0 : o.offset);

				if (scroll <= -delta) {
					scroll = -delta;
					arr.push(scroll);
					break;
				}

				arr.push(scroll);
			}
		}

		return arr;
	}

	getScroll() {
		var o = this.options;

		if (o.fullscreen) {
			return 1;
		}

		return o.scroll > this.length - 1 ? this.length : o.scroll;
	}

	// vytvoření nekonečného carouselu
	createInfinite() {
		var o = this.options;

		if (o.fullscreen) {
			var $cloneFirst = this.$items.first().clone(true).addClass('clone').removeAttr('id').data('sk-carousel-clone', 0);
			var $cloneLast = this.$items.last().clone(true).addClass('clone').removeAttr('id').data('sk-carousel-clone', this.length - 1);

			this.$element.append($cloneFirst).prepend($cloneLast);

			// required for lazyloading (items are cloned after lozad starts loading them)
			$().add($cloneFirst).add($cloneLast).find('[data-lazyload]').removeAttr('data-loaded');
			$cloneFirst.trigger('contentload');
			$cloneLast.trigger('contentload');

			return 1;
		}

		// todo infinite carousel
		return 0;
	}

	// timery
	interval() {
		this.pager.next();
	}

	clearInterval() {
		this.mainTimer = clearTimeout(this.mainTimer);
	}
	resetInterval() {
		if (this.options.timeout) {
			this.mainTimer = clearTimeout(this.mainTimer);
			this.mainTimer = setTimeout($.proxy(function () { this.interval(); }, this), this.options.timeout);
		}
	}
}

export default Carousel;
